import type { ReactElement } from 'react'
import { createContext, useContext, useEffect, useState } from 'react'

const AuthContext = createContext<string | undefined>(undefined)

type Props = {
  children: ReactElement
}

const AuthProvider = ({ children }: Props) => {
  const [initialState, setInitialState] = useState('')

  useEffect(() => {
    const { referrer } = document

    if (referrer) {
      // Start listening to AEM response
      window.addEventListener(
        'message',
        (event) => {
          if (event.data.id !== 'gb_aem_response') {
            return
          }

          const { user } = event.data

          if (user) {
            setInitialState(JSON.parse(user))
          }
        },
        false,
      )

      // Post message to AEM
      const message = {
        id: 'gb_form_ready',
      }
      window.parent.postMessage(message, referrer)
    }
  }, [])

  return (
    <AuthContext.Provider value={initialState}>{children}</AuthContext.Provider>
  )
}

const useAuth = () => {
  return useContext(AuthContext)
}

export { AuthProvider, useAuth }
